export class TemplateIsInUse extends Error {
  message = 'Esta plantilla está en uso y no puede ser eliminada';
}
